module.exports = __webpack_public_path__ + "static/media/cades-logo.3bcb7e6a.png";